import React, { PureComponent } from 'react';

import classNames from 'classnames';
import { TableFooter, TableRow, TableCell } from 'components/table';
import PropTypes from 'prop-types';

import DataTablePagination from './DataTablePagination';

class DataTableFooter extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string
  };

  render() {
    const { children, className } = this.props;
    const classComponent = classNames('data-table-footer', className);

    return (
      <TableFooter className={classComponent}>
        {children ? children : this.renderDefault()}
      </TableFooter>
    );
  }

  renderDefault() {
    return (
      <TableRow>
        <TableCell>
          <DataTablePagination />
        </TableCell>
      </TableRow>
    );
  }
}

export default DataTableFooter;
